import { PlatformDetect } from './platform/platform-detect';
import { InjectionToken } from '@angular/core';
import { CustomerInfo, UserInfo } from '@models/tracking-model';
import { FactoryService } from '@services/common/factory.service';
import { AccountService } from '@services/common/account.service';
import { JSBridgeService } from '@services/common/jsbridge.service';
declare const window: any;

export interface TrackingInterface {
  setTracking(params: any, setEntryPoint?: boolean);
  setUserTrack(params: any);
  initTracking();
}

class SetTrack implements TrackingInterface {
  private lang = this.factorySer.language;

  constructor(
    private factorySer: FactoryService,
    private platform: PlatformDetect,
    private acctSer: AccountService,
    private jsBridgeSer: JSBridgeService
  ) {}

  async initTracking() { 
    console.log('init tracking..', document.referrer);
    const data: any = {
      env: window.env,
      language: this.lang,
      previous_page: document.referrer || ''
    }
    this.acctSer.getOaFans();
    this.acctSer.getApHolder();
    window.autoTrack(data);
  }

  async setTracking(params: any, setEntryPoint?: boolean): Promise<void> {
    console.log('track params..', JSON.stringify(params));
    if (window.trackingEnable && window.customTrack) {
      const miniParams = this.platform.isMiniP() ? {
        open_id: this.factorySer.getOpenId() || null,
        union_id: this.factorySer.getUnionId() || null,
        is_oa_fans: this.acctSer.isOaFans || await this.acctSer.getOaFans()
      } : null;

      const appParams = this.platform.isApp() ? await this.getAppParams() : null;

      const isMember = sessionStorage.getItem('isMember');
      const analyticsModel:Partial<CustomerInfo> = {
        store: 'SHDRConsumer',
        language: this.lang,
        swid: this.factorySer.getSWID(),
        platform: this.platform.getPlatform(),
        is_ap_holder: this.acctSer.isApHolder || await this.acctSer.getApHolder(),
        is_member: isMember ? isMember === 'true' : null, // 上报bool型
        entry_point: setEntryPoint? this.getEntryPoint() : sessionStorage.getItem('entry_point') ||  '',
        ...miniParams,
        ...appParams,
        ...params
      }
      console.log('profile params ready',analyticsModel)
      window.customTrack(analyticsModel)
    }
  }

  /**
   * 用户属性上报
   */
  async setUserTrack(params){
    console.log('userTrack params:', params);
    if(window.trackingEnable && window.userTrack && params){
        const miniParams = this.platform.isMiniP() ? {
          open_id: this.factorySer.getOpenId() || null,
          union_id: this.factorySer.getUnionId() || null,
          is_oa_fans: this.acctSer.isOaFans || await this.acctSer.getOaFans()
        } : null;
        const data:UserInfo = {
          swid: params.swid,
          is_member: params.isMember, // 上报bool型
          is_ap_holder: this.acctSer.isApHolder || await this.acctSer.getApHolder(),
          ...miniParams
        }
        console.log('profile user track params ready',data)
        window.userTrack(data)
    }
  }

  private async getAppParams() { 
    let info = this.factorySer.getSessionInfo('trackLocationInfo', true);
    if (!info) {
      const resp = await this.jsBridgeSer?.callJSBridge('getTrackLocationInfo');
      if (resp?.resultCode === 0) {
        info = resp?.locationInfo;
        sessionStorage.setItem('trackLocationInfo', JSON.stringify(info));
      }
    }
    return {
      is_in_property: info?.is_in_property
    }
  }

  private getEntryPoint() {
    const channel = this.factorySer.getChannel();
    const business = this.factorySer.getBusiness();
    const trackingId = this.factorySer.getEntryCode();
    return `${channel ? channel : ''}${business ? '_' + business : ''}${trackingId ? '_' + trackingId : ''}`;
  }
}

const TrackingFactory = (
  factorySer: FactoryService,
  platform: PlatformDetect,
  acctSer: AccountService,
  jsBridgeSer: JSBridgeService
) => {
  return new SetTrack(factorySer, platform, acctSer, jsBridgeSer);
}

export const SH_TRACKING = new InjectionToken<TrackingInterface>('sh.tracking');

export const trackingProvider = {
  provide: SH_TRACKING,
  useFactory: TrackingFactory,
  deps: [FactoryService, PlatformDetect, AccountService, JSBridgeService],
}